/*
    Форма для отображения списков с переходами на страницы

    при добавлении этой формы на страницу надо:

    - добавить пропс "CaptionPage" - название страницы
    - добавить пропс "ListData" - через который передать массив данных
    - добавить прорс FilterList - массив с названиями столбцрв, по которым будет происходить поиск
    - добавить пропс "FillOnePosition" - для прорисовки одиночной позиции.
            В функции прорисовки позиции указать функцию при выборе  "" - которая 

    - добавить пропс "CancelFind" - если пользователь отказывается от выбора

    - необязательно, пропс InPage - позиций на странице

    - необязательный пропс 'DopSearch' - как еще искать (имя поля [field] и значение [value]) ! пока реализован только один фильтр
*/

import React from 'react';
import './ListShow.css';
import '../css/Main.css';
import { useState, useEffect } from 'react'
import KeyBoardShort from '../elements/KeyBoardShort.js'
import unique from '../modules/unique.js'


function ListShow(props) {
  
    const [filter_text, SetFilterText] = useState("");                  // фильтр поиска
    const [position_show_list, SetPositionShowList] = useState("");     // список видимых позиций

    const [list_begin, SetListBegin] = useState(0);                     // начало показа
    const [show_qty, SetShowQty] = useState(10);                        // по сколько позиций показывать

    //const [current_page, SetCurrentPage] = useState(1);                 // текущая страница для показа
    const [find_qty, SetFindQty] = useState(0);                         // сколько позиций нашлось по фильтру


  useEffect(() => {
      
    FillPositions();

  }, []);

  useEffect(() => { FillPositions(); }, [filter_text]);         // при изменении фильтра будем вызывать функцию
  useEffect(() => { FillPositions(); }, [props.ListData]);      // при изменении данных переберем список
  useEffect(() => { FillPositions(); }, [props.DopSearch]);     // при изменении дополнительного фильтра
  useEffect(() => { FillPositions(); }, [list_begin]);          // кол-во позиций на странице
  useEffect(() => { SetShowQty(props.InPage); }, [props.InPage]);    // кол-во позиций на странице



  

  

  return (
        <>
            <div className="page-caption-1">{ props.CaptionPage }</div>

            <div className="input-group mb-1">
                <span className="input-group-text col-1">Фильтр</span>
                <span className="input-group-text col">{ filter_text }</span>
                
                <button type="button" className="btn btn-secondary" onClick={ ClearFilter }>X</button>
                <span className='col-1'></span>
                <button type="button" className="col-2 btn btn-secondary cancel-select-client" onClick={ CancelSelect }>Отмена</button>
            </div>


            <KeyBoardShort onKeyboardClick={ onKeyboardClick }/>


            <div className="listshow-navigation d-flex align-items-center ">
                 { getListNavigationPages() } 
            </div>


            <div className="container-fluid">
                { position_show_list }
            </div>           

                
        </>  
  );


    // показать нужное ко-во позиций по фильтру
    function FillPositions()
    {    
        let begin = list_begin;
        let qty = show_qty;

        let finded_qty = 0;

        var res = [];

        for(var i in props.ListData)
        {
            let position = props.ListData[i];
            let txt = filter_text.toUpperCase();            

            if(filter_text != "")
            {
                let is_success_find = false;
                for(var j in props.FilterList)
                {
                    let cell_name = props.FilterList[j];
                    if(cell_name !== undefined && cell_name != null && cell_name != "" && position[cell_name] != null)
                        if(position[cell_name].toUpperCase().includes(txt) == true)
                        {
                            is_success_find = true;
                            break;             
                        }
                }
                if(is_success_find == false) continue;
            }            

            // проверим на дополнительный фильтр
            if(props.DopSearch !== undefined && props.DopSearch != null && props.DopSearch != "")
            {
                let dop = props.DopSearch.field;
                let dop_val = props.DopSearch.value;
                if(dop !== undefined && dop != null && dop != "")
                {
                    if(position[dop] === undefined || position[dop] == null || !position[dop].includes(dop_val)) continue;
                }
            }


            // значит эта позиция подходит под параметры

            finded_qty ++;          // прибавим количество найденных           
            if(begin > 0) { begin --; continue; }           // пропускаем, если показывать не с первого                        
            if(--qty < 0) continue;                         // пропускаем, если уже не надо показывать            
            res.push(props.FillOnePosition(position));      // добавляем клиента в список показа

        }

        SetFindQty(finded_qty);

        SetPositionShowList(res);
    }

    // очистить фильтр
    function ClearFilter() { SetFilterText(""); }

    // возвратить страницы навигации
    function getListNavigationPages()
    {
            let page_count = parseInt(find_qty / show_qty);
            if(page_count * show_qty < find_qty) page_count ++;

            // !!!!!!!!!!!!!! Пока не заморачиваемся, делаем так !!!!!!!!!!!!!!
            // НАДО ИСПРАВЛЯТЬ!
            if(page_count > 12) page_count = 12;
            // !!!!!!!!!!!!!!

            let select_page = parseInt(list_begin / show_qty);

            let pages = [];
            for(let i = 0; i < page_count; i++)
            {
                let obj;
                if(i == select_page) obj = <span key={ unique() } className="page-nav select" >{ i + 1 }</span>;
                else obj = <span key={ unique() } className="page-nav" onClick={ (e) => PageChange(i) }>{ i + 1 }</span>;
                pages.push(obj);
            }

            return <>
                <div className="col-2">Найдено: <strong>{ find_qty }</strong></div>
                <div className="col-9">
                    <div className="row">
                        { pages }
                    </div>
                </div>
            </>
    }

  // пользователь кликает на страницу для перемещения
  function PageChange(page_num)
  {
        let num = show_qty * page_num;
        SetListBegin(num);        
  }


  // ползователь кликает в экранную клавиатуру
  function onKeyboardClick(simbol)
  {
        let text = filter_text + simbol;
        SetFilterText(text);
  }

  // пользователь отказывается от выбора
  function CancelSelect()
  {
        props.CancelFind();
  }


}

export default ListShow;
